import { Background } from 'type/background';
import { BaseService } from './baseService';

class BackgroundService extends BaseService<Background> {
  controllerName = 'background';
}

export const backgroundService = new BackgroundService();
